import { makeStyles } from "@material-ui/core";

export const emptyDetailsStyles = makeStyles((theme) => ({
  container: {
    background: "#FFFFFF",
    color: "#000",
    border: "1px dashed rgba(209, 212, 222, 1)",
    borderRadius: "8px",
    display: "flex",
    padding: "32px 24px",
    justifyContent: "center",
    alignItems: "center",
    "& .MuiTypography-root": {
      marginBottom: "15px",
    },
  },
  imageContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  title: {
    fontFamily: "Inter",
    fontWeight: 600,
    fontSize: theme.typography.pxToRem(22),
    color: "#000",
  },
  description: {
    fontFamily: "Lato",
    fontWeight: 400,
    fontSize: theme.typography.pxToRem(16),
  },
}));
